<script>
import EntrepotDesktopView from "./EntrepotDesktopView.vue";

/**
 * Desktop create/edit layout bridge.
 * Renders EntrepotDesktopView using the parent EntrepotIndex instance as
 * context so template bindings and $refs stay on index.vue (provide/inject).
 */
export default {
  name: "EntrepotDesktopBridge",
  inject: ["entrepot"],
  render() {
    const entrepot = this.entrepot;
    const viewOptions = EntrepotDesktopView.options || EntrepotDesktopView;
    const render = viewOptions.render;

    if (!entrepot || typeof render !== "function") {
      return null;
    }

    const options = entrepot.$options;
    const prevStaticRenderFns = options.staticRenderFns;
    const prevScopeId = options._scopeId;

    options.staticRenderFns = viewOptions.staticRenderFns;
    if (viewOptions._scopeId) {
      options._scopeId = viewOptions._scopeId;
    }

    try {
      return render.call(entrepot, entrepot.$createElement);
    } finally {
      options.staticRenderFns = prevStaticRenderFns;
      options._scopeId = prevScopeId;
    }
  },
};
</script>
